import { MediaViewerItem } from '@place/media-viewer'
import dayjs from 'dayjs'

import { generatePath, isNotEmptyArray } from '@local/utils'

import { MediaType, UseOpenMediaViewer_ReviewGroupFragment } from '@web/gql/graphql'
import { isTypename } from '@web/libs/apollo/typeGuard'
import { BASE_PATH, IS_DEV, PROOF_LABEL_MAP } from '@web/libs/constants'
import routes from '@web/libs/constants/routes'

export const convertReviewGroupToViewer = (reviewGroup: UseOpenMediaViewer_ReviewGroupFragment) => {
  const { author, visit, mediaItems, visitKeywords } = reviewGroup

  const visitKeywordCodes = visitKeywords.map(keyword => keyword.code)

  const visitedDateTime = dayjs(reviewGroup.visitedDateTime)
  const isPastYear = visitedDateTime.isBefore(dayjs(), 'year')

  const reviewContent = {
    visitCount: visit?.visitCount,
    ...(author && {
      author: {
        nickname: author.profile.nickname,
        imageUrl: author.profile.imageUrl ?? undefined,
        useThumbnail: false,
        url: BASE_PATH + generatePath(routes.HOME_REVIEW, { userId: author.id }),
        borderImageUrl: author.profile.border?.imageUrl ?? undefined,
      },
    }),
    isFollowing: author?.isFriend,
    text: reviewGroup.text ?? undefined,
    date: visitedDateTime.format(`${isPastYear ? 'YY.' : ''}M.D.dd`),
    rating: reviewGroup.rating ?? undefined,
    sourceTitle: PROOF_LABEL_MAP.review[reviewGroup.selectedProof.type] ?? undefined,
    votedKeywords: reviewGroup.votedKeywords.map(({ code, text, icon }) => ({
      code: code,
      displayName: text.korean ?? '',
      iconUrl: icon,
    })),
    visitKeywords: reviewGroup.place?.visitCategories
      .map(visitCategory => {
        return {
          category: visitCategory.subTitle.korean,
          keywords: visitCategory.keywords
            .filter(keyword => visitKeywordCodes.includes(keyword.code))
            .map(keyword => keyword.text.korean),
        }
      })
      .filter(({ keywords }) => isNotEmptyArray(keywords)),
  }

  const mediaViewerItems = mediaItems.map<MediaViewerItem>((mediaItem, index) => {
    if (isTypename(mediaItem, 'VideoItem')) {
      if (mediaItem.isIllegalVideo) {
        return {
          originalUrl: mediaItem.thumbnail,
          imgUrl: mediaItem.thumbnail,
          no: index + 1,
          id: index.toString(),
          type: MediaType.Image,
          ...reviewContent,
        }
      } else {
        return {
          originalUrl: mediaItem.thumbnail,
          imgUrl: mediaItem.thumbnail,
          no: index + 1,
          id: index.toString(),
          videoSourceUrl: `${mediaItem.playback?.url}?providerEnv=${IS_DEV ? 'dev' : 'real'}`,
          type: MediaType.Video,
          ...reviewContent,
        }
      }
    }

    return {
      originalUrl: mediaItem.url,
      imgUrl: mediaItem.url,
      no: index + 1,
      id: index.toString(),
      type: MediaType.Image,
      ...reviewContent,
    }
  })

  return mediaViewerItems
}
